import axios from 'axios';
import config from 'config';

const { baseURL } = config;

export const axiosService = axios.create({ baseURL });

axiosService.interceptors.request.use((config) => {
  config.headers.Authorization = localStorage.getItem('accessToken');
  return config;
});

axiosService.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    const originalConfig = error.config;
    const refreshToken = await localStorage.getItem('refreshToken');
    if (
      error?.response?.status === 401 &&
      refreshToken &&
      error.config &&
      !originalConfig._isRetry
    ) {
      try {
        originalConfig._isRetry = true;

        const response = await axios.post(`${config.baseURL}/auth/refresh`, {
          refreshToken,
        });

        localStorage.setItem(
          'accessToken',
          `Bearer ${response.data.accessToken}`
        );
        localStorage.setItem('refreshToken', response.data.refreshToken);

        return axiosService.request(originalConfig);
      } catch (e: unknown) {
        if (e instanceof Error) throw new Error(e.message);

        throw e;
      }
    }

    throw error;
  }
);
